(() => {
  class BeddingOffer extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.config = JSON.parse(this.querySelector('[data-bedding-config]').textContent);
      this.variants = this.config.variants;
      this.filter = 'all';
      this.form = this.querySelector('[data-buy-form]');
      this.sizeSelect = this.querySelector('[data-size]');
      this.quantity = this.querySelector('[data-quantity]');
      this.hero = this.querySelector('.bo-hero');
      this.status = this.querySelector('[data-form-status]');
      this.busy = false;
      this.money = (cents) => this.config.currency === 'MYR' ? 'RM' + new Intl.NumberFormat('en-MY', { maximumFractionDigits: 2 }).format(cents / 100) : new Intl.NumberFormat(this.config.locale || 'en', { style: 'currency', currency: this.config.currency, minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(cents / 100);
      const requested = new URL(location.href).searchParams.get('variant');
      this.current = this.variants.find(v => String(v.id) === requested) || this.variants.find(v => v.id === this.config.defaultVariant) || this.variants.find(v => v.available) || this.variants[0];
      if (!this.current) {
        this.status.textContent = this.config.labels.unavailable;
        return;
      }
      this.sizeSelect.addEventListener('change', () => this.changeSize(this.sizeSelect.value));
      this.form.addEventListener('submit', event => { event.preventDefault(); this.purchase(false); });
      this.querySelector('[data-buy-now]').addEventListener('click', () => this.purchase(true));
      this.querySelector('[data-sticky-add]').addEventListener('click', () => this.purchase(false));
      this.querySelectorAll('[data-qty]').forEach(button => button.addEventListener('click', () => {
        this.quantity.value = Math.min(99, Math.max(1, this.quantityValue() + Number(button.dataset.qty)));
      }));
      this.quantity.addEventListener('change', () => { this.quantity.value = this.quantityValue(); });
      this.querySelectorAll('[data-filter]').forEach(button => button.addEventListener('click', () => {
        this.filter = button.dataset.filter;
        this.querySelectorAll('[data-filter]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        this.renderGrid();
      }));
      this.dialog = this.querySelector('[data-zoom-dialog]');
      this.querySelector('[data-zoom]').addEventListener('click', () => this.dialog.showModal());
      this.querySelector('[data-close-zoom]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); });
      this.querySelectorAll('[data-photo-step]').forEach(button => button.addEventListener('click', () => {
        const photos = this.current.images;
        this.photoIndex = (this.photoIndex + Number(button.dataset.photoStep) + photos.length) % photos.length;
        this.showPhoto();
      }));
      window.addEventListener('popstate', () => {
        const id = new URL(location.href).searchParams.get('variant');
        const match = this.variants.find(v => String(v.id) === id);
        if (match) { this.current = match; this.render(false); }
      });
      this.render(false);
    }
    quantityValue() {
      const n = Number(this.quantity.value);
      return Number.isInteger(n) && n >= 1 ? Math.min(n, 99) : 1;
    }
    sizeVariants() {
      return this.variants.filter(v => v.size === this.current.size);
    }
    changeSize(size) {
      const same = this.variants.find(v => v.product === this.current.product && v.print === this.current.print && v.size === size);
      const matches = this.variants.filter(v => v.size === size);
      const next = same || matches.find(v => v.available) || matches[0];
      if (!next) {
        this.sizeSelect.value = this.current.size;
        this.querySelector('[data-selection-status]').textContent = this.config.labels.unavailable;
        return;
      }
      this.current = next;
      this.render();
      this.querySelector('[data-selection-status]').textContent = same ? '' : this.config.labels.printChanged;
    }
    choose(id, scroll) {
      const next = this.variants.find(v => v.id === id);
      if (!next) return;
      this.current = next;
      this.render();
      if (scroll) {
        this.querySelector('.bo-product-layout').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
        this.sizeSelect.focus({ preventScroll: true });
      }
    }
    makeChoice(variant, card) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = card ? 'bo-print-card' : 'bo-swatch';
      button.dataset.variantChoice = String(variant.id);
      button.setAttribute('aria-pressed', String(variant.id === this.current.id));
      button.setAttribute('aria-label', variant.print + (variant.available ? '' : ' — ' + this.config.labels.soldOut));
      const image = document.createElement('img');
      image.src = variant.thumb;
      image.alt = variant.print;
      image.width = 320;
      image.height = 320;
      image.loading = 'lazy';
      image.decoding = 'async';
      button.append(image);
      if (card) {
        const label = document.createElement('span');
        label.className = 'bo-card-name';
        label.textContent = variant.print;
        const action = document.createElement('span');
        action.className = 'bo-card-action';
        action.textContent = variant.available ? this.config.labels.viewPrint : this.config.labels.soldOut;
        button.append(label, action);
      } else if (!variant.available) {
        const label = document.createElement('span');
        label.className = 'bo-sold-label';
        label.textContent = this.config.labels.soldOut;
        button.append(label);
      }
      if (!variant.available) button.classList.add('is-sold-out');
      button.addEventListener('click', () => this.choose(variant.id, card));
      return button;
    }
    renderGrid() {
      const grid = this.querySelector('[data-print-grid]');
      const variants = this.sizeVariants().filter(v => this.filter === 'all' || v.category === this.filter);
      grid.replaceChildren(...variants.map(v => this.makeChoice(v, true)));
      this.querySelector('[data-grid-empty]').hidden = variants.length !== 0;
      this.querySelector('[data-grid-size]').textContent = this.config.labels[this.current.size];
    }
    showPhoto() {
      const src = this.current.images[this.photoIndex] || this.current.image;
      this.hero.src = src;
      this.hero.removeAttribute('srcset');
      this.hero.alt = this.current.print + ' — ' + this.config.labels[this.current.size];
      const zoom = this.querySelector('[data-zoom-image]');
      zoom.src = src;
      zoom.alt = this.hero.alt;
    }
    canPurchase() {
      return this.config.purchaseEnabled && this.current.available && this.current.price === this.config.prices[this.current.size] && this.config.currency === 'MYR' && !this.busy;
    }
    render(updateUrl = true) {
      const v = this.current;
      const price = this.money(this.config.prices[v.size]);
      this.querySelectorAll('[data-price]').forEach(el => { el.textContent = price; });
      this.querySelector('[data-print-name]').textContent = v.print;
      this.querySelector('[data-sticky-name]').textContent = this.config.labels[v.size] + ' · ' + v.print;
      this.querySelector('[data-variant-id]').value = v.id;
      this.sizeSelect.value = v.size;
      this.querySelector('[data-selection-status]').textContent = v.available ? '' : this.config.labels.soldOut;
      this.photoIndex = 0;
      this.showPhoto();
      this.querySelector('.bo-photo-nav').hidden = v.images.length < 2;
      this.querySelectorAll('[data-size-col]').forEach(el => el.classList.toggle('is-selected', el.dataset.sizeCol === v.size));
      const dimensions = { Single: '90 × 190 cm', Queen: '152 × 190 cm', King: '182 × 190 cm' };
      this.querySelector('[data-dimensions]').textContent = this.config.labels[v.size] + ': ' + dimensions[v.size];
      const list = this.sizeVariants();
      const start = Math.max(0, list.findIndex(item => item.id === v.id) - 1);
      this.querySelector('[data-swatches]').replaceChildren(...list.slice(start, start + 6).map(item => this.makeChoice(item, false)));
      for (const option of this.sizeSelect.options) {
        option.disabled = !this.variants.some(item => item.size === option.value);
      }
      this.renderGrid();
      this.updateButtons();
      this.status.textContent = !v.available || !this.config.purchaseEnabled ? '' : this.canPurchase() ? '' : this.config.labels.pricePending;
      if (updateUrl) {
        const url = new URL(location.href);
        url.searchParams.set('variant', String(v.id));
        history.replaceState({}, '', url);
      }
    }
    updateButtons() {
      this.querySelectorAll('[data-add],[data-buy-now],[data-sticky-add]').forEach(button => {
        button.disabled = !this.canPurchase();
        button.setAttribute('aria-busy', String(this.busy));
      });
    }
    async purchase(checkout) {
      if (!this.canPurchase()) return;
      this.busy = true;
      this.updateButtons();
      this.status.textContent = this.config.labels.adding;
      try {
        const response = await fetch(this.config.routes.add, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: this.current.id, quantity: this.quantityValue() }] })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : this.config.labels.error);
        const next = new URL(checkout ? this.config.routes.checkout : this.config.routes.cart, location.origin);
        location.assign(next.toString());
      } catch (error) {
        this.status.textContent = error.message || this.config.labels.error;
        this.busy = false;
        this.updateButtons();
      }
    }
  }
  if (!customElements.get('bedding-offer')) customElements.define('bedding-offer', BeddingOffer);
})();
